import { escapeHTML } from 'cadenza/utils/escape-html';
import { mark } from 'cadenza/utils/mark/mark';

export function escapeAndMarkHTML (str, leadingP = true) {
  return mark(escapeHTML(str), leadingP);
}
